import React,  {useEffect, useRef, useState} from "react";
import { Link   } from "react-router-dom";

import {ArrowNext} from  'components/icons/arrow-next';
import {ChartNetwork} from  'components/icons/chart-network';
import {GlobalMarket} from  'components/icons/global_market';
import {IndustryIcon} from  'components/icons/industry-icon';
import {ChartGearIcon} from  'components/icons/chartgear-icon';
import {number_format,APP_URL , formatINR , cleanCompanyName, formatCompanyShortName } from 'components/config/Common';

import {
  useCompanyQueryIndicesByComp,
  useCompanyQueryPeerByComp,
  
} from 'data/company';

export default function Peersection({companyinfo}) {
    const [showMore, setShowMore] = useState(false);

  // How many tags to show initially
  const initialCount = 4;
  
    const {
      indicesofcomp,
      isLoading: loading,
      error:errorindicescomp,
    } = useCompanyQueryIndicesByComp(companyinfo?.id);


    const {
      peerofcomp,
      isLoading: loadingpeer,
      error:errorpeercomp,
      lable_array:lblarray,
    } = useCompanyQueryPeerByComp(companyinfo?.id);

  
    
    const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setVisible(entry.isIntersecting);
      },
      { threshold: 0.5 }
    );

    if (ref.current) observer.observe(ref.current);

    return () => {
      if (ref.current) observer.unobserve(ref.current);
    };
  }, []);


const indicesArray = Array.isArray(indicesofcomp) ? indicesofcomp : [];
    console.log("indicesofcomp",indicesofcomp);
   // Which tags to show
  const visibleTags = showMore ? indicesArray : indicesArray.slice(0, initialCount);

  return (
      <section className="bg-white shadow-md z-50 rounded-xl">
        <h2 className="text-2xl font-semibold p-5">Peer Companies</h2>
        <div></div>
       
        {loading?
        null
        :
        <>
         {indicesofcomp.length > 0 &&
         <div className="w-full py-1 px-5">
          <div className="flex flex-wrap gap-3">
             {indicesofcomp.length > 0 && <div  className="text-sm">Part of:</div>}
             {Array.isArray(visibleTags) &&  visibleTags.map((keyyear, valyear) => (
            <>
              <div className="text-xs text-accent-700 px-2 py-1 bg-accent-200 rounded-3xl ">
               <Link className="text-accent" to={`${process.env.REACT_APP_URL}/indices/${keyyear?.id}`}>
               {keyyear?.symbol}
                </Link> 
                </div>
            </>
           ))}

           {indicesofcomp.length > initialCount && (
          <button
            className="text-accent text-sm underline"
            onClick={() => setShowMore(!showMore)}
          >
            {showMore ? "Show less" : "Show more"}
          </button>
        )}
        </div>
         </div>
          }
         </>
        }


        {loadingpeer?
        null
        :
         <div className="w-full py-4">
          <div className=" gap-x-6 gap-y-2">
           <div ref={ref}
            class="relative overflow-x-auto bg-neutral-primary-soft shadow-xs rounded-base ">
            <table 
              
             class="w-full text-sm text-left border-0 rtl:text-right text-body">
                <thead class="bg-neutral-secondary-soft border-b border-default">
                    <tr >
                        {/*<th scope="col" class="px-6 py-2 font-medium">
                           S.No
                        </th>*/}
                        <th scope="col" class="px-6 py-2 font-medium">
                           Name
                        </th>
                         {Object.entries(lblarray).map(([keyyear, valyear]) => (
                            <th scope="col" className="text-right px-6 py-2 font-medium">{valyear?.name}</th>
                          ))}
                    </tr>
                </thead>
                <tbody>
                  {Object.keys(peerofcomp || {}).length === 0 ? (
                  <div className="p-5 text-heading"> data is not ready yet , please check again
                                </div>
                    ) : (<>
                    {Object.entries(peerofcomp).map(([period, qresults],index) => {
                  return(<React.Fragment key={period}>     
                            <tr className="group cursor-pointer odd:bg-gray-50 even:bg-white">
                              {/*<td className={`px-6 py-2 text-black sticky left-0 z-20  `} >
                                {index+1}
                                </td> */}
                              <td className={`px-2 md:px-6 py-2 sticky left-0 z-20 bg-white group-odd:bg-gray-50
`} >
                                <div className={`flex gap-1 whitespace-nowrap items-center  `}>
                                    <Link className="text-accent" to={`${process.env.REACT_APP_URL}/company/${qresults?.cinfo[index]?.symbol}`}>
                                    {formatCompanyShortName(qresults?.cinfo[index]?.name)}
                                    </Link>
                                  </div>
                                </td>
                              {Object.entries(qresults?.values).map(([key, qresultsval]) => (
                                  <td className={`px-6 py-2 text-heading text-wrap font-normal text-right`} >{qresultsval ? formatINR(qresultsval,2) : null}</td>
                              ))}
                              </tr>
                            </React.Fragment>)
                        })}  
                        </>
                        )}    
                </tbody>
              </table>
           </div>
            {/*peerofcomp.map((keyyear, valyear) => (
            <div  key={valyear}
                className="flex py-1 odd:bg-gray-50 even:bg-white"
              >
              <div className="text-sm  px-2 py-1 ">{valyear}</div>
              <div className="text-sm text-accent px-2 py-1 ">{valyear}</div>
            </div>
           ))*/}
        </div>
         </div>
        }
      </section> 
  );
}
